<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">

        <h2>Weaving Software</h2>
        <p>
            The software packages listed below support files in the <a href='http://www.mhsoft.com/wif/wif.html' target='_blank'>Weaving Information File (WIF) format</a>.
            All of the drafts downloaded from Handweaving.net use WIF format because many different weaving software packages will read this.
        </p>
        <p>
            Many more weaving packages than are listed here will likely work with WIFs downloaded from this site.
        </p>
        <hr style='clear:both; display: block'/>

        <div>
            <h3>WeaveIt</h3>
            <img class='logo-image right-padding bottom-padding' :src='getWeavingSoftwareImageUrl("weaveit1.png")' />
            <span>
                Canyon Art, LLC  provides weaving software for several platforms.
                <b>iWeaveIt</b> is a basic drawdown editing mobile app for  tablets and phones and runs on the IOS and 
                Android platform.   It is available on  iPads, Android tablets and Kindle Fire tablets.  All version will open 
                handweaving.net files for display and editing. 
                <b>WeaveIt Pro</b> is an advanced drawdown and editing software plus many advanced tools for designs.  
                Versions of WeavePro are available on  Windows 10  platform for PCs and on MacOS 10 platform for 
                Macs.  These programs also will accept files from handweaving.net for display and editing.
                Learn the details of these products at: <a href='http://www.weaveit.com' target='_blank'>http://www.weaveit.com</a>
            </span>
        </div>

        <hr style='clear:both; display: block'/>
        <div>
        <h3 class='top-padding'>Fiberworks PCW</h3>
            <img class='logo-image right-padding bottom-padding' :src='getWeavingSoftwareImageUrl("pcwlogo.jpg")' />
            <span>
                <b>Fiberworks PCW</b>&nbsp;&nbsp;&nbsp;&nbsp;Weaving Design Software that thinks like weavers do!
                <br/><br/>
                Three levels of proficiency.  Great flexibility without making it difficult. Enter drafts easily and accurately. Adjust colours and see it happen instantly in your design. Make thick or thin threads for unique effects. Over 80 different blocks with Block Substitution.  Instant Network drafting. Extensive copy, paste, repeat, transform functions.
                <br/><br/>
                Design your own blocks.  Rearrange shafts and treadles with the Shaft shuffler.  Interleaf and Overlay for designing with parallel lines.  Sketchpad features, like reduce colours, transparent paste and open weaving drafts.   And lots more. Come and see!
                <br/><br/>
                <a href='http://www.fiberworks-pcw.com' target='_blank'>http://www.fiberworks-pcw.com</a>
            </span>
        </div>

        <hr style='clear:both; display: block'/>
        <div>
        <h3>ArahWeave</h3>
            <img class='logo-image right-padding bottom-padding' :src='getWeavingSoftwareImageUrl("arahne-logo.png")' />

            <span>
                <b>ArahWeave</b> runs on Linux operating system (Novell SUSE, RedHat, Mandrake, Fedora), or Windows with virtual machine.
                <br/><br/>
                Features include: integrated dobby and jacquard CAD/CAM system, demo version supports WIF loading, saving and printing,
                PANTONE (R) for fashion and home, up to 50 shafts, weave up to 32000 x 32000 ends/picks, graphical browsing of fabrics,
                weaves, images, warp/weft patterns, jacquard cards, superior on-line simulation in real 1:1 size and density, warp or
                weft pattern on the simulation with mouse, and more!
                <br/><br/>                
                Demo version comes with free ArahPaint paint program (works without limits)
                and demo version of ArahDrape (works, you can save images and print, but you cannot save new projects).
                <br/><br/>
                ArahWeave Personal Edition costs 1000 EUR, and supports
                saving in Arahne's native format, enabling colorimetry,
                fancy yarns, denting/regulator, maximum weave size 2048x2048
                and saving to handloom jacquard formats (AVL J1P, Digital Weaving TC-1,
                TIFF, PNG, GIF, BMP).
                <br/><br/>            
                Check the web site <a href='http://www.arahne.si' target='_blank'>http://www.arahne.si</a> for on-line tutorials, manuals in PDF format and freely downloadable demo (no registration required).
            </span>
        </div>
        <hr style='clear:both; display: block'/>
        <div style='clear:both; display: block'>
            <h3 class='top-padding'>pixeLoom</h3>
            <img class='logo-image right-padding bottom-padding' :src='getWeavingSoftwareImageUrl("pixeLoom.png")' />
            <span>
                <b>pixeLoom</b> provides easy to use tools for editing drafts, planning
                projects, and virtual sampling.
                <br/><br/>
                This software is Windows&reg; and MacOS&reg;compatible.
                <br/><br/>
                Tutorials and free 30-day trial version available on <a href="http://www.pixeLoom.com" target='_blank'>http://www.pixeLoom.com</a>.
            </span>
        </div>
        <hr style='clear:both; display: block'/>
        <div>
            <h3 class='top-padding'>WeavePoint</h3>

            <img class='logo-image right-padding bottom-padding' :src='getWeavingSoftwareImageUrl("weavepoint1.png")' />

            <span>
                <b>WeavePoint</b> is software for advanced weaving design - an efficient
                tool for creating, editing and analyzing textile patterns and colorways and
                keeping a pattern archive.
                <br/><br/>
                For hand loom weavers and textile designers.
                Very easy to learn and use. Includes project calculator. Various loom
                interface options. Trial version that opens WIF patterns is available.
                <br/><br/>
                Supports Windows operating systems.
                <br/><br/>
                Web site: <a href='http://www.weavepoint.com' target='_blank'>http://www.weavepoint.com</a>
            </span>
        </div>
        <hr style='clear:both; display: block'/>
        <div>
            <h3>WIF Visualizer</h3>

            <span>
                <b>WIF Visualizer</b> a free web-based tool for displaying WIFs.
                <br/><br/>
                This is found at: <a href='http://softweave.com/html/software/WifVisualizer.html' target='_blank'>http://softweave.com/html/software/WifVisualizer.html</a><br><br>
                WIF Visualizer is created and distributed by <a href='http://www.softweave.com' target='_blank'>Jane Eisenstein</a>.
            </span>
        </div>        
    </b-container>

</template>

<script>
import mailChimpSignup from './MailChimpSignup.vue'
import helpUsButton from './HelpUsButton.vue'
import mediaService from '../mixins/mediaService.js'
export default {
    mixins: [mediaService],
    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup
    },
    created() {
        this.$store.commit('setPageTitle', 'Weaving Software List')
    }
}
</script>

<style scoped>
.logo-image {
    width: 265px;
    max-width: 265px;
    float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/WeavingSoftware.vue